export default function ({ store, route, redirect, res }) {
  const active_pt = store.state.auth.active_pt;
  const authorization_levels = route.meta.map((meta) => {
    if (meta.roles !== undefined) {
        if (!helpers.isEmpty(active_pt) && meta.roles.indexOf(active_pt.type) > -1) {
          return true;
        }

        return false;
    }
  });

  if (authorization_levels.indexOf(true) <= -1) {
    return redirect('/panel');
  }
}
